@if (config.buttons) {
  @if (config.buttons.auth || config.buttons.contactUs) {
    <div class="NavButtons">
      @if (config.buttons.contactUs) {
        <zip-button
          class="NavButton NavButton--contact"
          [config]="{
            level: 'low',
            content: config.buttons.contactUs.buttonText,
          }"
          (zipButtonClicked)="toggleContactUs()"
        >
        </zip-button>
      }
      @if (config.buttons.auth) {
        @if (data.isUserLoggedIn) {
          <zip-button
            class="NavButton"
            [config]="config.buttons.auth.logout"
            (zipButtonClicked)="logout()"
          >
          </zip-button>
        } @else {
          <a routerLink="/">
            <zip-button
              class="NavButton"
              [config]="config.buttons.auth.login"
              (zipButtonClicked)="login()"
            >
            </zip-button>
          </a>
        }
      }
    </div>
  }
}
